/* unplugin-vue-components disabled */import { render } from "./blankBottom.vue?vue&type=template&id=c902e286&scoped=true"
import script from "./blankBottom.vue?vue&type=script&lang=js"
export * from "./blankBottom.vue?vue&type=script&lang=js"

import "./blankBottom.vue?vue&type=style&index=0&id=c902e286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c902e286"]])

export default __exports__